<template>
  <div :class="giveMeClassContainer">
    <div
      :class="['dataLine_PDataLine', giveMeClassDataline]"
      v-if="Object.entries(value).length > 0"
    >
      <div class="titleDataLine" v-if="showTitle">
        <slot name="title" :data="value"></slot>
      </div>
      <div
        class="fieldDataLine"
        :style="giveMeWidthFiled(key)"
        v-for="(key, index) in keys"
        :key="index + 'c'"
        v-show="isEmptyShow(key)"
      >
        <div class="separator_PDataLine" v-if="showSeparators && index > 0" />
        <div :class="['fieldTextDataLine', giveMeDivider(key)]" :style="dameStyles(key)">
          <div>
            <div class="fieldTituloDataLine">
              {{ giveMeTitleTitle(key) }}
            </div>
            <div :class="['fieldTextoDataLine', dameClase(key)]" @click="click(key)">
              <span :class="['fieldTextoDataLine', dameClase(key)]">
                <slot :name="key" :dataField="value[key]">
                  {{ dameTexto(key) }}
                </slot>
              </span>
              <b-badge :variant="dameViewClass(key)" class="dataLinebadge">{{
                dameview(key)
              }}</b-badge>
            </div>
            <div
              class="divEnlargeDataLine"
              :style="dameTop(key)"
              v-if="verAmplicacion(key)"
              @mouseleave="mouseleave"
            >
              <div class="divDataLineClose">
                <p-icon
                  icon="x-square-fill"
                  class="datalineMaxSize"
                  type="bootstrap"
                  @click="mouseleave"
                >
                </p-icon>
              </div>
              <div class="divEnlargeDataLineTitulo">{{ giveMeTitleTitle(key) }}</div>
              <div>
                <slot :name="'large_' + key" :dataField="value[key]">
                  {{ value[key] }}
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actionDataLine">
        <div class="actionSlot_Dataline">
          <slot name="actions"> </slot>
        </div>

        <div v-show="keysActionIcons.length > 0">
          <span
            v-for="(keyActionIcons, index) in keysActionIcons"
            :key="index + 'ac'"
            @click="click(keyActionIcons)"
          >
            <p-icon
              :icon="fieldsActionIcons[keyActionIcons].icon"
              :type="fieldsActionIcons[keyActionIcons].itype"
              :iclass="fieldsActionIcons[keyActionIcons].iclass"
              class="dedo"
              :title="$t(fieldsActionIcons[keyActionIcons].ititle)"
              v-if="showCondition(keyActionIcons)"
            ></p-icon>
          </span>
        </div>
      </div>
    </div>
    <div class="dataLineEmpty" v-else>
      {{ $t("dataline.empty") }}
    </div>
    <div class="foot_PDataLine">
      <slot name="foot"> </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { format } from "date-fns";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDataLineFields } from "@/components/look/PDataLine/variables.types";

@Component
export class PDataLine extends Vue {
  @Prop({ required: true }) value!: any;
  @Prop({ required: false }) fields!: IDataLineFields;
  @Prop({ required: false, default: false }) showTitle!: boolean;
  @Prop({ required: false, default: true }) showBorder!: boolean;
  @Prop({ required: false, default: false }) widthContent!: boolean;
  @Prop({ required: false, default: false }) showSeparators!: boolean;
  @Prop({ required: false, default: "" }) classContainer!: string;
  @Prop({ required: false, default: "space-between" }) justifyContent!:
    | "space-between"
    | "center"
    | "flex-start"
    | "flex-end"
    | "space-around"
    | "space-evenly";

  get giveMeClassContainer(): string {
    let returnTemp: string;
    if (this.showBorder) {
      returnTemp = "containerBorder_PDataLine";
    } else {
      returnTemp = "container_PDataLine";
    }
    if (this.widthContent) {
      returnTemp = returnTemp + " widthContent_PDataLine";
    }
    if (this.classContainer) {
      returnTemp = returnTemp + " " + this.classContainer;
    }

    return returnTemp;
  }
  get giveMeClassDataline(): string {
    return this.justifyContent + "_PDataLine";
  }
  get keys(): string[] {
    if (this.fields != undefined) {
      return Object.keys(this.fields);
    } else {
      return Object.keys(this.value);
    }
  }

  get keysActionIcons(): string[] {
    return Object.keys(this.fieldsActionIcons);
  }
  get fieldsActionIcons(): any {
    const fieldsActionIcons: any = {};

    Object.keys(this.fields).forEach((key: string) => {
      if (!key.indexOf("actionIconClick")) {
        fieldsActionIcons[key] = this.fields[key];
      }
    });
    return fieldsActionIcons;
  }
  isEmptyShow(key: string): boolean {
    if (!key.indexOf("actionIconClick")) {
      return false;
    } else
      return !(
        this.fields[key].emptyShow != undefined &&
        !this.fields[key].emptyShow &&
        (this.value[key] === "" || !this.value[key])
      );
  }
  getReturTemp(key: string, property: string): boolean {
    if (this.fields[key].showCondition.operator === "equal") {
      if (
        this.value[this.fields[key].showCondition.field] ===
        this.fields[key].showCondition.condition[property]
      ) {
        return true;
      }
    } else if (this.fields[key].showCondition.operator === "noequal") {
      if (
        this.value[this.fields[key].showCondition.field] !=
        this.fields[key].showCondition.condition[property]
      ) {
        return true;
      }
    } else if (this.fields[key].showCondition.operator === "noContains") {
      if (
        this.value[this.fields[key].showCondition.field].indexOf(
          this.fields[key].showCondition.condition[property]
        ) === -1
      ) {
        return true;
      }
    }
    return false;
  }
  showCondition(key: string): boolean {
    if (this.fields[key].showCondition != undefined) {
      let returTemp = false;
      for (const property in this.fields[key].showCondition.condition) {
        returTemp = this.getReturTemp(key, property);
      }
      return returTemp;
    } else {
      return true;
    }
    // field: "mimeTye", operator: "equal", condition: { value_1: "", value_2: "" }
  }
  getReturnTemp(key: string): string {
    if (Array.isArray(this.value[key])) {
      let returnTemp = "";
      this.value[key].forEach((element: string) => {
        returnTemp = returnTemp + element + ",  ";
      });
      return returnTemp.substring(0, returnTemp.length - 3);
    } else if (this.value[key] === "") {
      return "--";
    } else {
      return this.value[key];
    }
  }
  dameTexto(key: string): string {
    if (this.fields[key].format != undefined) {
      if (this.value[key] != "") {
        return format(new Date(this.value[key]), this.fields[key].format);
      } else {
        return "--";
      }
    } else if (this.fields[key].maxSizeText != undefined) {
      return this.limitarCaracteres(key);
    } else if (this.fields[key].transtaleText != undefined) {
      return this.$t(this.fields[key].transtaleText);
    } else if (this.fields[key].transtaleItem != undefined) {
      return this.$t(this.fields[key].transtaleItem + this.value[key]);
    } else if (this.fields[key].view != undefined) {
      return "";
    } else {
      return this.getReturnTemp(key);
    }
  }
  dameview(key: string): string {
    if (this.fields[key].view != undefined) {
      if (this.fields[key].view === "validate") {
        if (this.value[key]) {
          return this.$t(this.fields[key].trueText);
        } else {
          return this.$t(this.fields[key].falseText);
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
  dameViewClass(key: string): string {
    if (this.fields[key].view != undefined) {
      if (this.fields[key].view === "validate") {
        if (this.value[key]) {
          return this.fields[key].trueVariant;
        } else {
          return this.fields[key].falseVariant;
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
  giveMeWidthFiled(key: string): string {
    if (this.fields[key].width != undefined) {
      return "flex: 0 0 " + this.fields[key].width;
    } else {
      return "flex: 1 1 auto";
    }
  }
  dameStyles(key: string): string {
    if (this.fields[key].style != undefined) {
      return this.fields[key].style;
    } else {
      return "";
    }
  }
  limitarCaracteres(key: string): string {
    const maxSizeText = this.fields[key].maxSizeText;
    if (this.value[key]?.length > maxSizeText) {
      return this.value[key].slice(0, maxSizeText) + "...";
    } else if (this.value[key] === "") {
      return "--";
    } else {
      return this.value[key];
    }
  }
  giveMeDivider(key: string): string {
    if (this.fields[key].divider != undefined && this.fields[key].divider) {
      return "fieldDataLineDivider";
    } else {
      return "";
    }
  }
  giveMeTitleTitle(key: string): string {
    if (this.fields[key].title != undefined) {
      return this.fields[key].title;
    } else {
      return "";
    }
  }
  dameTop(key: string): string {
    const caracteresAncho = 56;
    return "top:-" + (this.value[key].length / caracteresAncho / 2 + 2) + "rem;";
  }
  dameClase(key: string): string {
    if (
      this.fields[key].maxSizeText != undefined &&
      this.value[key] &&
      this.value[key].length > this.fields[key].maxSizeText
    ) {
      return "datalineMaxSize";
    } else if (!key.indexOf("actionClick")) {
      return "datalineAction";
    } else if (this.fields[key].list != undefined) {
      return "datalineList";
    } else {
      return "";
    }
  }

  ampliarKey = "";
  click(key: string): void {
    if (
      this.fields[key].maxSizeText != undefined &&
      this.value[key] &&
      this.value[key].length > this.fields[key].maxSizeText
    ) {
      this.ampliarKey = key;
    } else if (!key.indexOf("actionClick") || !key.indexOf("actionIconClick")) {
      this.$emit("click", {
        id: this.value[this.fields[key].idItem],
        idItem: this.fields[key].idItem,
        ...this.fields[key].click,
      });
    }
  }
  mouseleave(): void {
    this.ampliarKey = "";
  }
  verAmplicacion(key: string): boolean {
    return this.ampliarKey === key;
  }
}
export default PDataLine;
</script>
<style lang="scss" scoped>
.widthContent_PDataLine {
  width: max-content;
}
.space-between_PDataLine {
  justify-content: space-between;
}
.center_PDataLine {
  justify-content: center;
}
.flex-start_PDataLine {
  justify-content: flex-start;
}
.flex-end_PDataLine {
  justify-content: flex-end;
}
.space-around_PDataLine {
  justify-content: space-around;
}
.space-evenly_PDataLine {
  justify-content: space-evenly;
}
.containerBorder_PDataLine,
.container_PDataLine {
  max-width: 100%;
  margin: 0;
  padding: 0;
  margin-bottom: 1rem;
}
.containerBorder_PDataLine {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  border-radius: 6px;
}
.dataLineEmpty {
  margin: 0;
  padding: 40px;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  text-align: center;
}

.dataLine_PDataLine {
  display: flex;

  flex-wrap: wrap;
}
.dataLine_PDataLine .titleDataLine {
  flex: 0 0 20%;
  padding: 15px 40px;
  background-color: #fafafa;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dataLine_PDataLine .actionDataLine {
  flex: 1 1 auto;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  display: flex;
  right: 0;
  justify-content: flex-end;
  align-items: center;
}
.dataLine_PDataLine .actionSlot_Dataline {
  padding-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.dataLine_PDataLine .actionDataLine span {
  margin-left: 20px;
}
.dataLine_PDataLine .fieldDataLine {
  display: flex;
  position: relative;
  align-items: center;
  padding: 15px 0;
}

.dataLine_PDataLine .fieldTextDataLine {
  padding: 0 30px;
}

.dataLine_PDataLine .fieldDataLineDivider {
  border-left: 1px solid #e9e9e9;
}
.dataLine_PDataLine .fieldTituloDataLine,
.dataLine_PDataLine .divEnlargeDataLineTitulo {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #979797;
  white-space: nowrap;
}
.dataLine_PDataLine .fieldTextoDataLine {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #808080;
  white-space: pre-wrap;
}

.dataLine_PDataLine .divEnlargeDataLine {
  position: absolute;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  overflow: auto;
  z-index: 5;
  min-width: 8rem;
  min-height: 8rem;
}

.dataLine_PDataLine .datalineMaxSize {
  cursor: pointer;
}
.dataLine_PDataLine .datalineAction {
  cursor: pointer;
  color: #665300;
}
.dataLine_PDataLine .datalineMaxSize:hover {
  opacity: 0.4;
}

.divDataLineClose {
  text-align: right;
  margin-top: -1rem;
  margin-right: -0.5rem;
}
.divEnlargeDataLineTitulo {
  margin-top: -1rem;
  margin-bottom: 1rem;
}
.dataLinebadge {
  padding: 5px;
}
.foot_PDataLine {
  background-color: rgba(0, 0, 0, 0.03);
}
.datalineList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.datalineList-item {
  min-width: 200px;
  display: list-item;
  padding-top: 4px;
}
.badge-ok.fieldTextoDataLine {
  color: var(--ok-font-color);
}
.badge-ko.fieldTextoDataLine {
  color: var(--ko-font-color);
}
.containerBorder_PDataLine.ok {
  box-shadow: 0 2px 5px 0 var(--ok-font-color);
}
.containerBorder_PDataLine.ko {
  box-shadow: 0 2px 5px 0 var(--ko-font-color);
}
.separator_PDataLine {
  border-left: 1px solid gainsboro;
  height: 100%;
}
</style>
